import React from 'react';

import PawLoader from './PawLoader';

const Svg = {
  pawLoader: PawLoader,
};

export type SvgType = keyof typeof Svg;

export interface SvgProps extends React.SVGProps<SVGSVGElement> {
  type: SvgType;
  className?: string;
}

export default ({ type, className, ...props }: SvgProps) => (
  <div className={className}>{React.createElement(Svg[type], props)}</div>
);
